
import { Component, Prop, Vue } from "nuxt-property-decorator";

// the deprecated variants should be removed over time
const deprecatedVariants = [
  "micro",
  "small",
  "small-secondary",
  "white-ghost",
  "white-large",
  "yellow-large",
];

const variants = [
  ...deprecatedVariants,
  "default",
  "white",
  "gray",
  "yellow",
  "black",
  "ghost",
  "icon",
  "text",
  "pellets-primary",
  "pellets-secondary",
] as const;

type ButtonVariant = typeof variants[number];

const sizes = ["default", "micro", "small", "big", "large"] as const;
type ButtonSize = typeof sizes[number];

@Component({})
export default class Button extends Vue {
  @Prop({ default: "default" })
  readonly size: ButtonSize;

  @Prop({ default: "default" })
  readonly variant: ButtonVariant;

  @Prop({ type: Boolean, default: undefined })
  readonly loading: boolean | undefined;

  @Prop({ type: Boolean, default: undefined })
  readonly fullWidth: boolean | undefined;

  @Prop({ type: Boolean, default: undefined })
  readonly inline: boolean | undefined;

  @Prop({ type: Boolean, default: undefined })
  readonly emphasize: boolean | undefined;

  created() {
    if (process.env.NODE_ENV === "development") {
      if (!sizes.includes(this.size)) {
        console.warn(`Unknown value for button size: '${this.size}'`);
      }
      if (!variants.includes(this.variant)) {
        console.warn(`Unknown value for button variant: '${this.variant}'`);
      }
      if (deprecatedVariants.includes(this.variant)) {
        console.warn(
          `Used variant '${this.variant}' is deprecated.
Consider using one of the following: [${variants
            .filter((v) => !deprecatedVariants.includes(v))
            .join(", ")}]
in combination with the "size" prop.
        `,
        );
      }
    }
  }
}
